import { Extension } from '@tiptap/core'
import { Plugin, PluginKey } from 'prosemirror-state'

export const SlashCommand = Extension.create({
    name: 'slashCommand',
    
    addOptions() {
        return {
            onTrigger: () => {},
        }
    },
    
    addProseMirrorPlugins() {
        const { options } = this;
        
        return [
            new Plugin({
                key: new PluginKey('slashCommand'),
                props: {
                    handleTextInput(view, from, to, text) {
                        // Only handle "/" at the start of a block or after a space
                        if (text === '/') {
                            const { state } = view;
                            const { $from } = state.selection;
                            
                            // Check if we're at the start of a block or after whitespace
                            const textBefore = $from.parent.textBetween(0, $from.parentOffset);
                            const isValidPosition = textBefore === '' || textBefore.endsWith(' ');
                            
                            if (isValidPosition) {
                                // Let the "/" be inserted first
                                const tr = state.tr.insertText('/', from, to);
                                view.dispatch(tr);
                                
                                // Then trigger the menu
                                setTimeout(() => {
                                    console.log('[SlashCommand] Triggering slash command menu at position:', from);
                                    if (options.onTrigger) {
                                        // Pass the position where "/" was inserted
                                        options.onTrigger(from);
                                    } else {
                                        console.warn('[SlashCommand] No onTrigger callback provided');
                                    }
                                }, 0);
                                
                                return true;
                            }
                        }
                        
                        return false;
                    }
                }
            })
        ]
    }
})